import { LayoutAtoms } from "./atoms";
import { LayoutMolecules } from "./molecules";
import { LayoutOrganisms } from "./organisms";


export * from './organisms';


export const LayoutComponents = [
    ...LayoutAtoms,
    ...LayoutMolecules,
    ...LayoutOrganisms,
]